import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";
import { withRouter, Prompt } from "react-router";
import classnames from "classnames";
import { toast } from "react-toastify";

import * as actions from "../../../../store/actions";
import constants, { getOnboardingPath } from "../../../../constants";

import Button from "../../../../components/formElements/button/Button";
import TextInput from "../../../../components/formElements/input/TextInput";
import Row from "../../../../components/uiElements/grid/Row";
import Card from "../../../../layout/Onboarding/Card";
import OnboardingIcon from "../../../../components/uiElements/icons/onboardingIcons/OnboardingIcon";
import SelectInput from "../../../../components/formElements/selectInput/SelectInput";
import {
  VALIDATE_PATIENT_CONTACT_INFO,
  REMOVE_VALIDATIONS,
} from "../../../../store/actions/actionTypes";

const ContactDetailsCard = ({
  personalPatientInfo,
  setPatientPersonalInfo,
  history,
  form,
  validateData,
  updatePatientContactDetails,
  removeValidations,
}) => {
  const heightStyles = {
    multiValue: styles => {
      return {
        ...styles,
        background: "var(--pallet-color)",
      };
    },
    multiValueLabel: styles => ({
      ...styles,
      color: "white",
    }),
    multiValueRemove: styles => ({
      ...styles,
      color: "white",
      ":hover": {
        backgroundColor: "transparent",
      },
    }),
    placeholder: styles => ({
      ...styles,
      color: "#bbc1d0",
    }),
    dropdownIndicator: styles => ({
      ...styles,
      paddingRight: 25,
      display: "inline",
    }),
  };

  const myRef = useRef();

  useEffect(() => {
    if (form && form.contact) {
      if (personalPatientInfo.dataLoaded && personalPatientInfo.dataChanged) {
        updatePatientContactDetails("update", () => {
          history.push(getOnboardingPath("/dosespotPatient"));
        });
      } else {
        updatePatientContactDetails("save", () => {
          history.push(getOnboardingPath("/dosespotPatient"));
        });
      }
    }

    // form.personalPatientInfo = false;
    // toast.error(form.address1, {
    //   position: constants.TOAST_POSITION,
    // });

    form.personalPatientInfo = false;
    // eslint-disable-next-line
  }, [form]);

  useEffect(() => {
    removeValidations();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      {/* <Prompt
        when={personalPatientInfo.dataChanged}
        message="You have unsaved changes, are you sure you want to leave?"
      /> */}

      <div
        ref={myRef}
        className={classnames(
          "onboarding-container"
          // personalPatientInfo.dataLoaded && !redirectedPath && "disable"
        )}
      >
        <p className="onboarding-header">
          Contact
          <br /> Details
        </p>
        <Row>
          <Card>
            <div className="mb-n4">
              <TextInput
                id="address1"
                error={form.address1}
                type="text"
                label="Address1 "
                value={personalPatientInfo.address1}
                onChange={val => setPatientPersonalInfo({ address1: val })}
              />
              <TextInput
                id="address2"
                type="text"
                label="Address2"
                value={personalPatientInfo.address2}
                onChange={val => setPatientPersonalInfo({ address2: val })}
              />
              <TextInput
                id="city"
                error={form.city}
                maxLength={15}
                type="text"
                label="City"
                value={personalPatientInfo.city}
                onChange={val => setPatientPersonalInfo({ city: val })}
              />
              <TextInput
                id="state"
                error={form.state}
                maxLength={2}
                type="text"
                label={
                  personalPatientInfo.state ? "State" : "Enter State by Code"
                }
                value={personalPatientInfo.state}
                onChange={val =>
                  setPatientPersonalInfo({ state: val.toUpperCase() })
                }
              />
              <TextInput
                id="country"
                error={form.country}
                maxLength={15}
                type="text"
                label="Country"
                value={personalPatientInfo.country}
                onChange={val => setPatientPersonalInfo({ country: val })}
              />
              <TextInput
                id="zipcode"
                error={form.zipcode}
                maxLength={5}
                type="number"
                label="Zip Code"
                value={personalPatientInfo.zipcode}
                onChange={val => setPatientPersonalInfo({ zipcode: val })}
              />
              <TextInput
                id="primaryphone"
                error={form.primary_phone}
                maxLength={10}
                type="number"
                label="Primary Phone"
                value={personalPatientInfo.primary_phone}
                onChange={val => setPatientPersonalInfo({ primary_phone: val })}
              />
            </div>
            <div className="mt-3 mb-5">
              <SelectInput
                menuPlacement="auto"
                error={form.primaryPhoneType}
                styles={heightStyles}
                isSearchable
                options={constants.PRIMARY_PHONE_TYPES}
                placeholder="Primary Phone Type"
                value={personalPatientInfo.primaryPhoneType}
                onChange={val =>
                  setPatientPersonalInfo({ primaryPhoneType: val })
                }
              />
            </div>
          </Card>

          <Button
            type="secondary"
            indicatorButton
            className={classnames(
              "float-right next-button",
              personalPatientInfo.dataLoaded && "enable"
            )}
            onClick={() =>
              (!personalPatientInfo.address1 &&
                !personalPatientInfo.city &&
                !personalPatientInfo.state &&
                !personalPatientInfo.country &&
                !personalPatientInfo.zipcode &&
                !personalPatientInfo.primary_phone &&
                !personalPatientInfo.primaryPhoneType) ||
              personalPatientInfo.dataChanged
                ? validateData(personalPatientInfo)
                : history.push(getOnboardingPath("/dosespotPatient"))
            }
            label={<OnboardingIcon type="nextButton" />}
          />
        </Row>
      </div>
    </>
  );
};

const mapStoreToProps = ({ onboarding, validation, auth }) => ({
  personalPatientInfo: onboarding.patientPersonalInfo,
  form: validation.data,
});

const mapDispatchToProps = dispatch => ({
  setPatientPersonalInfo: updatedData =>
    dispatch(actions.setPatientPersonalInfo(updatedData)),

  updatePatientContactDetails: (action, cb) =>
    dispatch(actions.updatePatientContactDetails(action, cb)),

  validateData: personalPatientInfo =>
    dispatch(
      actions.validateData(VALIDATE_PATIENT_CONTACT_INFO, personalPatientInfo)
    ),
  removeValidations: () =>
    dispatch(actions.validateData(REMOVE_VALIDATIONS, {})),
});

export default withRouter(
  connect(mapStoreToProps, mapDispatchToProps)(ContactDetailsCard)
);
